<template>
  <waybill-create-r-x-real
    v-if="show"
    @reset="reset"
    :waybillSplitId="waybillSplitId"
    :isSee="isSee"
    :type="type"
    :commandIds="commandIds"
  ></waybill-create-r-x-real>
</template>

<script>
import WaybillCreateRXReal from "./WaybillCreateRXReal.vue";
export default {
  components: {
    WaybillCreateRXReal,
  },
  props: {
    commandIds:{
      type:String,
      require:false,
      default(){
        return '[]'
      }
    },
    waybillSplitId: {
      type: String,
      require: false,
      default() {
        return null;
      },
    },
    isSee: {
      type: String,
      require: false,
      default() {
        return "";
      },
    },
    type:{
      type:String,
      require:false,
      default:'add'
    }
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    async reset() {
      this.show = false;
      await this.$nextTick();
      this.show = true;
    },
  },
};
</script>

<style>
</style>